import { render, staticRenderFns } from "./NeedsOnboarding.vue?vue&type=template&id=9c1f6246&scoped=true&"
import script from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NeedsOnboarding.vue?vue&type=style&index=0&id=9c1f6246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f6246",
  null
  
)

export default component.exports